import React from 'react';
import { Wifi, WifiOff, Battery, Signal } from 'lucide-react';
import { PieChart, Pie, Cell, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import './shared-analytics.css';

const DeviceAnalytics = () => {
  const deviceStatusData = [
    { name: 'Online', value: 4, color: '#16a34a' },
    { name: 'Offline', value: 2, color: '#dc2626' },
    { name: 'Not Assigned', value: 1, color: '#f59e0b' }
  ];

  const uptimeData = [
    { day: 'Mon', uptime: 98.5, devices: 7 },
    { day: 'Tue', uptime: 97.2, devices: 7 },
    { day: 'Wed', uptime: 99.1, devices: 7 },
    { day: 'Thu', uptime: 96.8, devices: 7 },
    { day: 'Fri', uptime: 98.9, devices: 7 },
    { day: 'Sat', uptime: 99.5, devices: 7 },
    { day: 'Sun', uptime: 97.8, devices: 7 }
  ];

  return (
    <div className="device-analytics">
      <div className="analytics-summary">
        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#f0fdf4', color: '#16a34a' }}>
            <Wifi size={24} />
          </div>
          <div className="card-content">
            <h3>Online Devices</h3>
            <div className="card-value">4</div>
            <div className="card-change positive">57% of total</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fef2f2', color: '#dc2626' }}>
            <WifiOff size={24} />
          </div>
          <div className="card-content">
            <h3>Offline Devices</h3>
            <div className="card-value">2</div>
            <div className="card-change negative">29% of total</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#f0f9ff', color: '#0891b2' }}>
            <Signal size={24} />
          </div>
          <div className="card-content">
            <h3>Avg. Uptime</h3>
            <div className="card-value">98.2%</div>
            <div className="card-change positive">+0.5% this week</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fef7ff', color: '#7c3aed' }}>
            <Battery size={24} />
          </div>
          <div className="card-content">
            <h3>Avg. Battery</h3>
            <div className="card-value">87%</div>
            <div className="card-change neutral">Normal range</div>
          </div>
        </div>
      </div>

      <div className="analytics-charts">
        <div className="chart-container">
          <div className="chart-header">
            <h3>Device Status Distribution</h3>
          </div>
          <div className="chart-content">
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={deviceStatusData}
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  dataKey="value"
                  label={({ name, value }) => `${name}: ${value}`}
                >
                  {deviceStatusData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="chart-container">
          <div className="chart-header">
            <h3>Weekly Uptime Trends</h3>
          </div>
          <div className="chart-content">
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={uptimeData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                <XAxis dataKey="day" stroke="#6b7280" />
                <YAxis stroke="#6b7280" domain={[95, 100]} />
                <Tooltip />
                <Bar dataKey="uptime" fill="#3b82f6" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="device-list">
        <h3>Device Status Details</h3>
        <div className="device-grid">
          {[
            { id: 'DEV-001', patient: 42, status: 'online', battery: 92, lastSeen: '2 min ago' },
            { id: 'DEV-002', patient: 43, status: 'offline', battery: 15, lastSeen: '2 days ago' },
            { id: 'DEV-003', patient: 44, status: 'offline', battery: 78, lastSeen: '1 day ago' },
            { id: 'DEV-004', patient: 45, status: 'online', battery: 88, lastSeen: '5 min ago' },
            { id: 'DEV-005', patient: 47, status: 'online', battery: 95, lastSeen: '1 min ago' },
            { id: 'DEV-006', patient: 48, status: 'online', battery: 82, lastSeen: '3 min ago' },
            { id: 'DEV-007', patient: 46, status: 'not_assigned', battery: 100, lastSeen: 'Never' }
          ].map((device) => (
            <div key={device.id} className="device-card">
              <div className="device-header">
                <span className="device-id">{device.id}</span>
                <span className={`device-status ${device.status}`}>
                  {device.status === 'online' ? <Wifi size={16} /> : <WifiOff size={16} />}
                  {device.status.replace('_', ' ')}
                </span>
              </div>
              <div className="device-info">
                <div>Patient: {device.patient}</div>
                <div>Battery: {device.battery}%</div>
                <div>Last seen: {device.lastSeen}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DeviceAnalytics;
